import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { format } from 'date-fns';
import type { PayrollPeriod } from './PayrollTypes';

interface PayrollHeaderProps {
  period: PayrollPeriod;
  onBack: () => void;
}

export const PayrollHeader: React.FC<PayrollHeaderProps> = ({ period, onBack }) => {
  return (
    <div className="flex items-center gap-4 mb-6">
      <Button 
        variant="outline" 
        onClick={onBack}
        className="flex items-center gap-2"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to Calendar
      </Button>
      <div>
        <h1 className="text-3xl font-bold">Payroll Processing</h1>
        <p className="text-muted-foreground">
          Pay period: {format(new Date(period.startDate), 'MMM dd, yyyy')} - {format(new Date(period.endDate), 'MMM dd, yyyy')}
        </p>
      </div>
    </div>
  );
};